import React, { Component } from 'react'

import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import Checkbox from '@material-ui/core/Checkbox'
import IconButton from '@material-ui/core/IconButton'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'

import './SalesInformation.css'

export default class SalesInformationChoice extends Component {
  state = {
    newChoice: '',
    selected: undefined
  }

  selectItem = index => () => {
    this.setState({
      selected: this.state.selected === index ? undefined : index
    })
  }
  changeNewChoice = e => {
    const newChoice = e.target.value
    this.setState({ newChoice })
  }
  addChoice = () => {
    const { newChoice } = this.state

    if (newChoice !== '' && newChoice !== undefined) {
      this.props.addChoice(newChoice)
      this.setState({ newChoice: '' })
    }
  }

  reorderChoice = (target, position) => () => {
    this.props.reorderChoice(this.state.selected, target, position)
    //modify
    this.setState({
      selected:
        this.state.selected < target
          ? position === 'before'
            ? target - 1
            : target
          : position === 'before'
            ? target
            : target + 1
    })
  }

  render() {
    const { selected, newChoice } = this.state
    const { values, removeChoice } = this.props
    return (
      <Grid container spacing={0}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6">Choix possible</Typography>

          <List>
            {values.map((value, index) => (
              <ListItem
                key={index}
                dense
                button
                onClick={this.selectItem(index)}
              >
                <Checkbox
                  disableRipple
                  checked={selected === index}
                  color="primary"
                />
                <ListItemText primary={value.value} />
                <ListItemSecondaryAction>
                  {selected !== undefined &&
                    selected !== index && (
                      <div>
                        <IconButton
                          onClick={this.reorderChoice(index, 'after')}
                        >
                          <ArrowDownwardIcon />
                        </IconButton>
                        <IconButton
                          onClick={this.reorderChoice(index, 'before')}
                        >
                          <ArrowUpwardIcon />
                        </IconButton>
                      </div>
                    )}
                  {selected === undefined && (
                    <IconButton onClick={removeChoice(index)}>
                      <RemoveIcon />
                    </IconButton>
                  )}
                </ListItemSecondaryAction>
              </ListItem>
            ))}
            <ListItem key="new" dense>
              <TextField
                className="sp-salesinformation--addchoice"
                label="Choix supplémentaire"
                placeholder="Ajoutez un choix..."
                fullWidth
                onChange={this.changeNewChoice}
                value={newChoice}
              />
              <ListItemSecondaryAction>
                <IconButton onClick={this.addChoice}>
                  <AddIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </Grid>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/sales-informations/SalesInformationChoice.js